import PropTypes from 'prop-types';
import styles from './Cta.module.scss';

/**
 * Wrapper component with a heading and subtext
 */
export default function Cta({
  heading, subText, children, fullScreen, gradient, standalone, transparent,
}) {
  const isFullScreen = standalone ? false : fullScreen;

  const componentClassName = [
    styles.cta,
    gradient ? styles['--gradient'] : '',
    standalone ? styles['--standalone'] : '',
    isFullScreen ? styles['--full-screen'] : '',
    transparent ? styles['--transparent'] : '',
  ].join(' ').trim();

  const containerClassName = [
    styles.cta__container,
    isFullScreen ? styles['--full-screen'] : '',
  ].join(' ').trim();

  return (
    <section className={componentClassName}>
      <div className={containerClassName}>
        {heading && (
          <div className={styles.cta__heading}>{heading}</div>
        )}
        {subText && (
          <div className={styles.cta__subtext}>{subText}</div>
        )}
        {children && (
          <div className={styles.cta__cta}>
            {children}
          </div>
        )}
      </div>
    </section>
  );
}

Cta.defaultProps = {
  heading: '',
  subText: '',
  children: null,
  fullScreen: true,
  gradient: false,
  standalone: false,
  transparent: false,
};

Cta.propTypes = {
  /**
   * CTA Heading
   */
  heading: PropTypes.string,
  /**
   * CTA Sub text
   */
  subText: PropTypes.string,
  children: PropTypes.node,
  /**
   * Is the block fullscreen or is it rendered in another container?
   */
  fullScreen: PropTypes.bool,
  /**
   * Use the gradient style CTA
   */
  gradient: PropTypes.bool,
  /**
   * Removes padding and background
   */
  standalone: PropTypes.bool,
  /**
   * Transaparent background
   */
  transparent: PropTypes.bool,
};
